import { connect } from 'react-redux';
import { compose } from 'redux';

import injectReducer from 'utils/injectReducer';
import CommandsGrid from '../components/CommandsGrid';
import { commandsEntityActions, commandsEntitySelectors } from 'containers/App/modules/entities/commands/commandsEntity.slice';
import { commandsPageActions, commandsPageSelectors } from '../modules/commands.slice';
import commandsPageReducer from '../modules/commands.slice';
import commandsEntityReducer from 'containers/App/modules/entities/commands/commandsEntity.slice';
import { selectDeviceTypesTreeDataNew, selectDeviceTypesIdToLabelMap } from 'containers/App/modules/app.slice';

const withCommandsPageReducer = injectReducer({
	key: 'commandsPage',
	reducer: commandsPageReducer,
});

const withCommandsEntityReducer = injectReducer({
	key: 'commandsEntity',
	reducer: commandsEntityReducer,
});

const mapStateToProps = (state) => {
	return {
		isLoading: commandsEntitySelectors.selectCommandsPending(state),
		data: commandsEntitySelectors.selectCommandsData(state),
		grid: commandsPageSelectors.selectCommandsGrid(state),
		lastRequestParams: commandsPageSelectors.selectLastRequestParams(state),
		deviceTypesTreeData: selectDeviceTypesTreeDataNew(state),
		deviceTypesIdToLabelMap: selectDeviceTypesIdToLabelMap(state),
	};
};

const withConnect = connect(mapStateToProps, {
	fetchCommands: commandsPageActions.fetchCommands,
	setGridParams: commandsPageActions.setGridParams,
	resetGridData: commandsPageActions.resetGridData,
});

export default compose(
	withCommandsPageReducer,
	withCommandsEntityReducer,
	withConnect
)(CommandsGrid);
